import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class CompanyTestimonialItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            background: '.m-companyTestimonialItem__background',
            color: '.m-companyTestimonialItem__color',
            avatar: '.m-companyTestimonialItem__avatar',
            claim: '.m-companyTestimonialItem__claim',
            name: '.m-companyTestimonialItem__name',
            postTitle: '.m-companyTestimonialItem__postTitle',
            preTitle: '.m-companyTestimonialItem__preTitle',
            position: '.m-companyTestimonialItem__position',
            avatarFallBackContainer: '.m-companyTestimonialItem__avatarFallBackContainer',
            inner: '.m-companyTestimonialItem__inner',
        };
    }

    getPropsFromDom() {
        return {
            fontColor: this.dom.inner ? this.dom.inner.getAttribute('data-font-color') : '',
            bgSrc: this.dom.background ? this.dom.background.getAttribute('data-bg-src') : '',
            brandColor: this.dom.color ? this.dom.color.getAttribute('data-brand-color') : '',
            avatarSrc: this.dom.avatar ? this.dom.avatar.getAttribute('data-avatar-src') : '',
            claim: this.dom.claim ? this.dom.claim.innerText : '',
            name: this.dom.name ? this.dom.name.innerText : '',
            preTitle: this.dom.preTitle ? this.dom.preTitle.innerText : '',
            postTitle: this.dom.postTitle ? this.dom.postTitle.innerText : '',
            position: this.dom.position ? this.dom.position.innerText : '',
            male: this.dom.avatarFallBackContainer
                ? (this.dom.avatarFallBackContainer.getAttribute('data-male') === 'true') : false,
            defaultIconColor: this.dom.avatarFallBackContainer
                ? this.dom.avatarFallBackContainer.classList.contains(
                    'm-companyTestimonialItem__avatarFallBackContainer--defaultColor',
                ) : false,
        };
    }
}
